'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSeed$002dId$0024 from "./presto.types$-Seed-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$61() {
  this.aH1 = null;
  this.aGZ = null;
  this.aH0 = false;
  this.aGX = null;
  this.aGY = false;
  this.aH2 = false;
  this.aH3 = false;
  this.aH1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$61 as $c_Lpresto_CredentialsView$$anon$61 };
$p = $c_Lpresto_CredentialsView$$anon$61.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$61;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$61() {
}
export { $h_Lpresto_CredentialsView$$anon$61 as $h_Lpresto_CredentialsView$$anon$61 };
$h_Lpresto_CredentialsView$$anon$61.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aH1;
});
$p.t = (function() {
  if ((!this.aH0)) {
    this.aGZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seed", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aH0 = true;
  }
  return this.aGZ;
});
$p.ae = (function() {
  if ((!this.aGY)) {
    this.aGX = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSeed$002dId$0024.$m_Lpresto_types$SeedId$().cs8(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aGY = true;
  }
  return this.aGX;
});
$p.w = (function() {
  if ((!this.aH3)) {
    this.aH2 = false;
    this.aH3 = true;
  }
  return this.aH2;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$61 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$61, "presto.CredentialsView$$anon$61", ({
  G3: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$61 as $d_Lpresto_CredentialsView$$anon$61 };
//# sourceMappingURL=presto.-Credentials-View$$anon$61.js.map
